export default __webpack_public_path__ + "static/media/forgot-password-password.5ccd999a.png";